<template>
  <div class="video-clips">
    <div
      v-for="(videoClip, index) in viewModel.VideoClips"
      :key="index"
      class="row row--mb-20"
    >
      <div class="col-xs-12 col-md-6">
        <video
          crossorigin="anonymous"
          controls="controls"
          class="video-clips__video-player"
        >
          <source
            :src="getVideoClipPreviewUrl(videoClip)"
            type="video/mp4"
          >
        </video>
      </div>
      <div class="col-xs-12 col-md-6">
        <div>
          <div
            :data-contentful-text="contentfulText('checkout-download-video-clip-expiration-notice').Id"
            class="video-clips__expiration-notice"
          >
            {{ expirationNotice }}
          </div>
          <div class="row video-clips__action-buttons">
            <div :class="shareButtonColumnClasses">
              <a
                :href="viewModel.ShareURL"
                class="button video-clips__share-button"
                target="_blank"
                @click="handleShareButtonClick"
              >
                <contentful-text :item="contentfulText('checkout-download-video-clip-share-button-label')" />
              </a>
            </div>
            <div
              v-if="showVideoDownload"
              class="col-xs-12 col-sm-6"
            >
              <a
                :href="getVideoDownloadUrl(videoClip)"
                class="button video-clips__download-button"
                download
                target="_blank"
              >
                <contentful-text :item="contentfulText('checkout-download-video-clip-download-button-label')" />
              </a>
            </div>
          </div>
        </div>
        <div
          v-if="showVideoDownload"
          class="video-clips__download-instructions"
        >
          <contentful-text :item="contentfulText('checkout-download-video-clip-download-instructions')" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GoogleAnalytics from '@Shared/lib/google-analytics'
import Moment from 'moment'

export default {
  name: 'VideoClips',
  computed: {
    viewModel () {
      return this.$store.state.viewModel
    },
    playerId () {
      return this.$store.state.playerId
    },
    showVideoDownload () {
      const occasionDate = new Moment(this.viewModel.OccasionDate)
      const now = new Moment()

      return now.diff(occasionDate, 'days') <= this.numDaysExpiresAfterEvent // occasion date is within n days of current
    },
    content () {
      return this.viewModel.PageContent
    },
    expirationNotice () {
      return this.contentfulTextFormatted('checkout-download-video-clip-expiration-notice', { numDaysExpiresAfterEvent: this.numDaysExpiresAfterEvent })
    },
    numDaysExpiresAfterEvent () {
      return 90
    },
    shareButtonColumnClasses () {
      return {
        'col-xs-12': true,
        'col-sm-6': true,
        'col-sm-offset-3': !this.showVideoDownload
      }
    }
  },
  methods: {
    getVideoClipPreviewUrl (videoClip) {
      return `https://content.jwplatform.com/videos/${videoClip.VideoKey}-640.mp4`
    },
    getVideoDownloadUrl (videoClip) {
      return `https://content.jwplatform.com/videos/${videoClip.VideoKey}-A58SBurp.mp4`
    },
    handleShareButtonClick () {
      GoogleAnalytics.trackEvent(
        'Video Clips',
        'click',
        'View & Share'
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.video-clips {
  margin-bottom: 40px;

  &__expiration-notice {
    margin-bottom: 40px;
    text-align: center;
  }

  &__video-player {
    width: 100%;
  }

  &__action-buttons {
    margin-bottom: 30px;
  }

  &__download-instructions {
    color: #333;
    margin-top: 7px;
    padding: 12px;
    background-color: #eee;
    font-size: 10px;
  }

  &__share-button {
    background-color: #fff;
    border: 2px solid $grad-color-blue;
    color: $grad-color-blue;
    font-size: 18px;
    font-weight: bold;
    line-height: 2.5;
    margin: 0 0 20px 0;
    text-align: center;
    width: 100%;
  }

  &__download-button {
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    width: 100%;
  }

  @media screen and (min-width: $screen-md-min) {
    &__share-button {
      margin: 0;
    }
  }
}

.row--mb-20 {
  margin-bottom: 30px;
}

.row--mb-30 {
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/grad-images/checkout-download/components/VideoClips.vue